export const TTS_STOP_REASONS = {
  COMPLETED: 'completed',
  USER_STOPPED: 'user_stopped',
  DICTATION_INTERRUPTED: 'dictation_interrupted',
  THREAD_SWITCHED: 'thread_switched',
  TAB_HIDDEN: 'tab_hidden',
  PAGE_NAVIGATION: 'page_navigation',
  ERROR: 'error',
} as const;

export type TtsStopReason = (typeof TTS_STOP_REASONS)[keyof typeof TTS_STOP_REASONS];
